import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useResourceCount } from '../../../hooks/useResourceCount'
import { UserRoleFilter } from '../../../types/user/userProfile'

import PageHeader from '../../../components/ui/pageHeader/PageHeader'
import { UsersList } from '../../../components/authenticated/management/user/usersList/UsersList'
import { UsersKpis } from '../../../components/authenticated/management/user/usersKpis/UsersKpis'


export const AdminUsers = () => {
  const { t } = useTranslation('users')
  const [widgetsRefreshKey, setWidgetsRefreshKey] = useState(0)
  const [roleFilter, setRoleFilter] = useState<UserRoleFilter>('ALL')
  const { count: usersCount } = useResourceCount(
    '/api/v1/profiles/count',
    roleFilter === 'ALL' ? {} : { roleType: roleFilter },
    widgetsRefreshKey
  )

  return (
    <>
      <PageHeader
        title={{
          eyebrow:
            usersCount === null
              ? undefined
              : t('users.page-header.eyebrow', {
                  count: usersCount,
                }),
          h1: t('users.page-header.title'),
        }}
        sub={t('users.page-header.subtitle')}
      />

      <div className="row g-4">
        <div className="col-12">
          <UsersKpis refreshTrigger={widgetsRefreshKey} />
        </div>
        <div className="col-12">
          <UsersList
            roleFilter={roleFilter}
            onRoleFilterChange={setRoleFilter}
            onUsersChange={() => setWidgetsRefreshKey(current => current + 1)}
          />
        </div>
      </div>
    </>
  )
}
